module.exports = __webpack_public_path__ + "img/events-2.c26a7d03.jpg";